module.exports = __webpack_public_path__ + "static/media/guest-Charlie.e95366e0.svg";